import packageInfo from '../../package.json';

export const environment = {
  env: 'production',
  production: true,
  clientName: packageInfo.name,
  clientVersion: packageInfo.version,
  googleTagManagerId: 'GTM-PJ2ZWT4',
  apiBaseUrl: 'https://prod-api.umma.io/v2',
  paypalClientId: 'AfePFTySMgeagpzTGl20cw5jQxVIGBb1Y2_BUPJH_3RvFi0yoIcr-nWbTSgBRMslx96KG2Nc7k2uUQMB',
};
